// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1e0c1ule{display:block}\n._4t3i1rxo{height:var(--_1fywwk4)}", ""]);
// Exports
module.exports = exports;
